// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__O97P_","category__label":"Category_category__label__GNGQT","category__content":"Category_category__content__3CAOf"};